const ARROW_START_DEG = 133;
const ARROW_END_DEG = 406;
const ARROW_DIFF_DEG = ARROW_END_DEG - ARROW_START_DEG;
const DONUT_DASH_LENGTH = 107;
const MAX_CIRCLE_POINT = 80.5;
const MAX_SCORE = 10;

export {
  ARROW_DIFF_DEG,
  ARROW_END_DEG,
  ARROW_START_DEG,
  DONUT_DASH_LENGTH,
  MAX_CIRCLE_POINT,
  MAX_SCORE,
};
